import { browser } from "../../../../services/device/device"

export default async function hasAudioInputAccess(){
    if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !navigator.mediaDevices.enumerateDevices){
        return false
    }
    return await getAudioInputAccessPermissionUsingEnumerateDevices()
}
async function getAudioInputAccessPermissionUsingEnumerateDevices(){
    return await navigator.mediaDevices.enumerateDevices().then((devices) => {
        return devices.find( device => device.kind === "audioinput" && device.label && device.deviceId)
      }).catch((err) =>{
        return false
      });
}

/**
 * Experimental feature, not available on Safari, IE, Samsung Internet and Android Webview.
 * Firefox doesn't work with microphone. So mostly only Chrome is working with this right now.
 * https://developer.mozilla.org/en-US/docs/Web/API/PermissionStatus/change_event
 */
export async function getAudioInputAccessState(){
    const browserName = browser.getBrowserName()
    if(browserName.toLowerCase().includes('firefox')) return null
    if(!navigator.permissions) return null
    return await getAudioInputAccessPermissionUsingPermissionsQuery()
}
async function getAudioInputAccessPermissionUsingPermissionsQuery(){
    return await navigator.permissions.query({name:'microphone'}).then(function(permissionStatus) {
        return permissionStatus.state
    });
}